<h1 class="text-center">Encrypt-Decrypt with AES</h1>  
  
<br>  
<div>  
  <div class="row">  
    <div class="col-sm-6">  
      <button type="button" class="btn btn-primary btn-lg btn-block">  
        Encryption  
      </button>  
      <br>  
      <div class="form-group">  
        <label for="txtTextToConvert">Plain Text</label>  
        <input type="text" class="form-control" placeholder="Enter text you want to encrypt" [(ngModel)]="plainText">  
      </div>  
  
      <div class="form-group">  
        <label for="txtPassword">Password</label>  
        <input type="text" class="form-control" placeholder="Enter encryption password" [(ngModel)]="encPassword">  
      </div>  
      <textarea class="form-control" readonly rows="3">{{conversionEncryptOutput}}</textarea>  
      <br>  
      <button type="button" class="btn btn-success float-right" (click)="convertText('encrypt')">Encrypt</button>  
    </div>  
    <div class="col-sm-6">  
      <button type="button" class="btn btn-dark btn-lg btn-block">  
        Decryption  
      </button>  
      <br>  
      <div class="form-group">  
        <label for="txtTextToConvert">Encrypted Text</label>  
        <input type="text" class="form-control" placeholder="Enter text you want to decrypt" [(ngModel)]="encryptText">  
      </div>  
  
      <div class="form-group">  
        <label for="txtPassword">Password</label>  
        <input type="text" class="form-control" placeholder="Enter decryption password" [(ngModel)]="decPassword">  
      </div>  
      <textarea class="form-control" readonly rows="3">{{conversionDecryptOutput}}</textarea>  
      <br>  
      <button type="button" class="btn btn-success float-right" (click)="convertText('decrypt')">Decrypt</button>  
    </div>  
  </div>  
</div>  


<hr class="mt-3 mb-3">
<div class="row mb-3">
  <div class="col-12 text-center">
    <h3>Test</h3>
  </div>
</div>

<div>  
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">  
        <label for="txtTextToConvert">IV</label>  
        <input type="text" class="form-control" placeholder="Enter IV" [(ngModel)]="iv">  
      </div>  
    </div>  

    <div class="col-sm-4">
      <div class="form-group">  
        <label for="txtTextToConvert">SALT</label>  
        <input type="text" class="form-control" placeholder="Enter SALT" [(ngModel)]="salt">  
      </div>  
    </div>  

    <div class="col-sm-4">
      <div class="form-group">  
        <label for="txtTextToConvert">Password</label>  
        <input type="text" class="form-control" placeholder="Enter Password" [(ngModel)]="password">  
      </div>  
    </div>  
  </div>

  <div class="row">  
    <div class="col-sm-6">  
      <button type="button" class="btn btn-primary btn-lg btn-block">  
        Encryption  
      </button>  
      <br>  
      <div class="form-group">  
        <label for="txtTextToConvert">Plain Text</label>  
        <input type="text" class="form-control" placeholder="Enter text you want to encrypt" [(ngModel)]="plainToEncrypt">  
      </div>  
  
      <div class="form-group">  
        <label for="txtPassword">Password</label>  
        <input type="text" class="form-control" placeholder="Enter encryption password" [(ngModel)]="passwordToEncrypt" disabled>  
      </div>  
      <textarea class="form-control" readonly rows="3">{{encrypted}}</textarea>  
      <br>  
      <button type="button" class="btn btn-success float-right" (click)="drosEncrypt()">Encrypt</button>  
    </div>  
    <div class="col-sm-6">  
      <button type="button" class="btn btn-dark btn-lg btn-block">  
        Decryption  
      </button>  
      <br>  
      <div class="form-group">  
        <label for="txtTextToConvert">Encrypted Text</label>  
        <input type="text" class="form-control" placeholder="Enter text you want to decrypt" [(ngModel)]="encryptedToDecrypt">  
      </div>  
  
      <div class="form-group">  
        <label for="txtPassword">Password</label>  
        <input type="text" class="form-control" placeholder="Enter decryption password" [(ngModel)]="passwordToDecrypt">  
      </div>  
      <textarea class="form-control" readonly rows="3">{{plainFromDecrypt}}</textarea>  
      <br>  
      <button type="button" class="btn btn-success float-right" (click)="drosDecrypt()">Decrypt</button>  
    </div>  
  </div>  
</div>  
<br>


// WEBPACK FOOTER //
// ./src/app/login-social/login-social.component.html